import React from 'react';
import { BaseComponent } from '../../base-component';
import './toast.css';
import { genClassName } from '../../utils';
import { COMPONENT } from '../../ui-event';

export default class Toast extends BaseComponent {
    state = {
        show: false,
        content: 'toast弹窗内容',
    }
    componentWillMount() {
        this.eventMgr.on(COMPONENT.TOAST.POPUP, (content,zIndex=11) => {
            this.show(content, zIndex);
        })
    }

    show(content, zIndex) {
        let {show} = this.state;
        if(show) return;
        this.setState({ content, show:true, zIndex });
        setTimeout(() => this.setState({show: false}), 3600)
    }

    render() {
        const { show, content, zIndex } = this.state;
        let toastClass = genClassName({
            'toast-show': show,
            'toast-hide': true,
        })
        return (
            <div className={toastClass} style={{zIndex:zIndex}}>
                {content}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/toast/index.js